export default "<template>\n    <slot></slot>\n</template>\n";